import Swiper, { Thumbs, Autoplay, FreeMode, Controller, Pagination, EffectFade } from 'swiper';

function isMobile() {
    return window.innerWidth < 1024
}

function toggleAudio (muted, audioControl) {
    if (muted) {
        $('.icon-audio-on', audioControl).css('display', 'inline')
        $('.icon-audio-off', audioControl).css('display', 'none')
    } else {
        $('.icon-audio-on', audioControl).css('display', 'none')
        $('.icon-audio-off', audioControl).css('display', 'inline')
    }
}

function slideChangeHandler(e, selectedSlide) {
    const self = e
	selectedSlide = $(selectedSlide);

    const timeupdateHandler = function (e) {
        const progress = ((e.target.currentTime / e.target.duration) * 100).toFixed(0)
        $('.progress-bar .progress', selectedSlide).width(`${progress}%`)
    };

    // state reset
    $('.swiper-slide video').off('timeupdate')
    $('.progress-bar', e.thumbs.swiper.$el).removeClass('active')
    $('.progress-bar .progress', e.thumbs.swiper.$el).width(0)
    const audioControl = $('.audio-control', e.$el.parent())
	let current_is_muted = true;

    if (e.params.currentVideo) {
		current_is_muted = e.params.currentVideo.get(0).muted;
        e.params.currentVideo.get(0).pause()
		e.params.currentVideo.off('timeupdate')
		e.params.currentVideo.off('ended')
    }

    // video event and playback reset
    const videoElement = $('video', $(e.visibleSlides[0]))
    if (videoElement.length > 0) {
        e.params.currentVideo = videoElement
        videoElement.get(0).currentTime = 0
        videoElement.on('timeupdate', timeupdateHandler)
        videoElement.one('ended',function(){
            // self.autoplay.start()
            self.slideTo((e.realIndex + 1) % 3)
        })

        // set active progress bar
        $('.progress-bar', selectedSlide).addClass('active')
        audioControl.css('display', 'block')
        // e.autoplay.stop()
        videoElement.get(0).play();
		videoElement.get(0).muted = current_is_muted;
    }
	else {
        e.params.currentVideo = null
        audioControl.css('display', 'none')
    }
}

// Hero toggle description
$(document).ready(function () {
	/*
		Questo è per nascondere il tasto "vedi altro" quando il testo non viene
		tagliato dal line-clamp
	*/
	$('.cutlines').each(function() {
		if (this.scrollHeight <= this.clientHeight) {
			$(this).siblings('.more-text').empty();
		}
	});

    var showMore = $('.show-more');
    var castList = $('.cast-list');

    $(showMore).click(function () {
        $(castList).toggleClass('open');

        if (this.innerHTML == "Vedi Altri") {
            this.innerHTML = "Vedi Meno";
        } else if (this.innerHTML == "Vedi Meno") {
            this.innerHTML = "Vedi Altri";
        } else {
            null
        }

        //$(this).html('Vedi meno')
    })

    var showChar = 140;
    var dots = "... ";
    var moreText = "Vedi altro";
    var lessText = "Vedi meno";

    $('.show-text').each(function () {
        var content = $(this).html();

        if (content.length > showChar) {
            var cont = content.substr(0, showChar);
            var restOfTheText = content.substr(showChar, content.length - showChar);
            var html = cont + '<span class="dots">' + dots + '</span><span class="morecontent"><span>' + restOfTheText + '</span><a href="" class="morelink">' + moreText + '</a></span>';
            $(this).html(html);
        }
    });

    var verticalSwiper1 = new Swiper(".ultime-uscite:nth-child(1)", {
		modules: [Autoplay, FreeMode, Controller],
        loop: true,
        loopedSlides: 3,
        spaceBetween: 16,
        slidesPerGroup: 1,
        slidesPerView: 'auto',
        slidesPerColumn: 'auto',
        direction: 'horizontal',
        watchSlidesProgress: true,
        autoplay: {
            delay: 0,
        },
        freeMode: true,
        speed: 10000,
        freeModeMomentum: false,
        breakpoints: {
            1024: {
                spaceBetween: 16,
                slidesPerGroup: 1,
                slidesPerView: 'auto',
                direction: 'vertical',
                slidesPerColumnFill: 'row',
            }
        },
        on: {
        }
    });
    var verticalSwiper2 = new Swiper(".ultime-uscite:nth-child(2)", {
		modules: [Autoplay, FreeMode, Controller],
        loop: true,
        loopedSlides: 3,
        spaceBetween: 16,
        slidesPerView: 'auto',
        slidesPerColumn: 'auto',
        direction: 'horizontal',
        watchSlidesProgress: true,
		autoplay: {
            delay: 0,
        },
        freeMode: true,
        speed: 10000,
        freeModeMomentum: false,
        pauseOnMouseEnter: true,
        breakpoints: {
            1024: {
                spaceBetween: 16,
                slidesPerGroup: 1,
                slidesPerView: 'auto',
                direction: 'vertical',
                slidesPerColumnFill: 'row',
            }
        },
        on: {
        }
    });

    verticalSwiper1.controller.control = verticalSwiper2;
    verticalSwiper2.controller.control = verticalSwiper1;

    $(".ultime-uscite").hover(function() {
        verticalSwiper1.autoplay.stop();
        verticalSwiper2.autoplay.stop();
        const transformCss = $('.swiper-wrapper',verticalSwiper1.$el).css('transform');
        const style = $('.swiper-wrapper',verticalSwiper1.$el).attr('style').replace(/transition-duration: ?[0-9]+ ?ms;/, 'transition-duration: 200ms;');
        $('.swiper-wrapper',verticalSwiper1.$el).attr('style', `transform: ${transformCss};transition-duration: 200ms;`);
        $('.swiper-wrapper',verticalSwiper2.$el).attr('style', `transform: ${transformCss};transition-duration: 200ms;`);

    }, function() {
        verticalSwiper1.autoplay.start();
    });
})

// Hero slider
var swiper = new Swiper(".hero-thumb", {
	modules: [FreeMode],
    loop: false,
    spaceBetween: 16,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true
});

var swiper2 = new Swiper(".hero-slider", {
	modules: [Thumbs, Autoplay, Pagination],

	/*
		Non viene utilizzata la funzione nativa per il loop di Swiper in quanto
		questa genera autonomamente duplicati delle slides, mandando in crisi il
		player Cloudinary. Invece, sull'evento di fine di un video, si seleziona
		la prossima slide su cui scorrere
	*/
    // loop: true,

    spaceBetween: 0,
	watchSlidesProgress: true,
    // autoplay: true,
    effect: 'fade',
    disableOnInteraction: false,
    thumbs: {
        swiper: swiper,
    },
    pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
    },
    on: {
        init: function (e) {
            const activeSlide = $('.swiper-slide-thumb-active', e.thumbs.swiper.$el)
            e.params.currentVideo = null

            /*
                Hack brutto per evitare la sovrapposizione tra il play() in
                slideChangeHandler() e quello dell'inizializzazione del player
                Cloudinary
            */
            setTimeout(() => {
                slideChangeHandler(e, activeSlide);
            }, 1000);

            const audioControl = $('.audio-control', e.$el.parent())
            if (e.params.currentVideo) {
                toggleAudio(e.params.currentVideo.get(0).muted, audioControl)
            }
            audioControl.on('click', function (){
                if (e.params.currentVideo) {
                    e.params.currentVideo.get(0).muted = !e.params.currentVideo.get(0).muted
                    toggleAudio(e.params.currentVideo.get(0).muted, audioControl)
                    console.log('video muted: ', e.params.currentVideo.get(0).muted)
                }
            })
        },
        slideChange: function (e) {
            const activeSlide = $('.swiper-slide-thumb-active', e.thumbs.swiper.$el)
        	slideChangeHandler(e, activeSlide)
        }
    }
});

var galleryThumbs = new Swiper('.gallery-thumbs', {
    spaceBetween: 10,
    centeredSlides: false,
    slidesPerView: 'auto',
    //touchRatio: 0.2,
    slideToClickedSlide: false,
    loop: false,
    loopedSlides: 4,
    watchActiveIndex: true,
    breakpoints: {
        1024: {
            slidesPerView: 4,
            spaceBetween: 16,
            slideToClickedSlide: true,
            centeredSlides: false,
        },
    },
    on: {
        slideChange: function (e) {
            if (isMobile()) {
                window.setTimeout(() => {
                    $('.swiper-slide-thumb-active', e.$el).removeClass('swiper-slide-thumb-active')
                    $('.swiper-slide-active', e.$el).addClass('swiper-slide-thumb-active')
                    galleryTop.slideToLoop(galleryThumbs.realIndex);
                }, 100)
            }

        },
        click: function (e) {
            if (isMobile()) {
                e.slideTo(e.clickedIndex)
            }
        }
    }
});
var galleryTop = new Swiper('.gallery-top', {
	modules: [Thumbs, EffectFade],
    spaceBetween: 0,
    effect: 'fade',
    loop: false,
    autoplay: false,
    loopedSlides: 4,
    watchActiveIndex: true,
    grabCursor: true,
    thumbs: {
        swiper: galleryThumbs,
    },
    on: {
        slideChange: function (e) {
            e.thumbs.swiper.slideTo(e.activeIndex)
        }
    }
});
